/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CacheRule } from '../models';
// @ts-ignore
import type { ExchangeProxyStateRequest } from '../models';
// @ts-ignore
import type { ExchangeProxyStateResponse } from '../models';
// @ts-ignore
import type { GetCacheMetricsResponse } from '../models';
// @ts-ignore
import type { GetCacheQueryInsightsResponse } from '../models';
// @ts-ignore
import type { GetCacheQueryTemplateResponse } from '../models';
// @ts-ignore
import type { GetCacheSummaryResponse } from '../models';
// @ts-ignore
import type { GetConnectionsMetricsResponse } from '../models';
// @ts-ignore
import type { GetInstanceProxyCacheMetricsResponse } from '../models';
// @ts-ignore
import type { GetPerformanceMetricsResponse } from '../models';
// @ts-ignore
import type { GetProxyQueriesResponse } from '../models';
// @ts-ignore
import type { ListCacheRulesResponse } from '../models';
// @ts-ignore
import type { Proxy } from '../models';
// @ts-ignore
import type { ProxyDatabaseUpdate } from '../models';
// @ts-ignore
import type { ProxyLogicalDatabaseConfig } from '../models';
// @ts-ignore
import type { ReportOperationalMetricsRequest } from '../models';
// @ts-ignore
import type { ReportPoolingMetricsRequest } from '../models';
// @ts-ignore
import type { ReportQueryMetricsRequest } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * CachingAPIApi - axios parameter creator
 * @export
 */
export const CachingAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a cache rule for a specific logical database behind a proxy.   Adds a per-table or per-query TTL override rule. Exactly one of table or  template_hash must be set on the rule.
         * @summary Create a cache rule for a proxy database
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the logical database within the proxy
         * @param {CacheRule} cacheRule 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPICreateCacheRule: async (organizationId: string, proxyId: string, databaseName: string, cacheRule: CacheRule, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cachingAPICreateCacheRule', 'organizationId', organizationId)
            // verify required parameter 'proxyId' is not null or undefined
            assertParamExists('cachingAPICreateCacheRule', 'proxyId', proxyId)
            // verify required parameter 'databaseName' is not null or undefined
            assertParamExists('cachingAPICreateCacheRule', 'databaseName', databaseName)
            // verify required parameter 'cacheRule' is not null or undefined
            assertParamExists('cachingAPICreateCacheRule', 'cacheRule', cacheRule)
            const localVarPath = `/database-optimizer/caching/v1alpha/organizations/{organizationId}/proxies/{proxyId}/databases/{databaseName}/rules`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"proxyId"}}`, encodeURIComponent(String(proxyId)))
                .replace(`{${"databaseName"}}`, encodeURIComponent(String(databaseName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cacheRule, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a proxy for a database instance
         * @summary Create a proxy for a database instance
         * @param {string} organizationId Organization identifier
         * @param {Proxy} proxy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPICreateProxy: async (organizationId: string, proxy: Proxy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cachingAPICreateProxy', 'organizationId', organizationId)
            // verify required parameter 'proxy' is not null or undefined
            assertParamExists('cachingAPICreateProxy', 'proxy', proxy)
            const localVarPath = `/database-optimizer/caching/v1alpha/organizations/{organizationId}/proxies`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(proxy, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a cache rule for a specific logical database behind a proxy.
         * @summary Delete a cache rule for a proxy database
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the logical database within the proxy
         * @param {string} id Cache rule identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIDeleteCacheRule: async (organizationId: string, proxyId: string, databaseName: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cachingAPIDeleteCacheRule', 'organizationId', organizationId)
            // verify required parameter 'proxyId' is not null or undefined
            assertParamExists('cachingAPIDeleteCacheRule', 'proxyId', proxyId)
            // verify required parameter 'databaseName' is not null or undefined
            assertParamExists('cachingAPIDeleteCacheRule', 'databaseName', databaseName)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cachingAPIDeleteCacheRule', 'id', id)
            const localVarPath = `/database-optimizer/caching/v1alpha/organizations/{organizationId}/proxies/{proxyId}/databases/{databaseName}/rules/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"proxyId"}}`, encodeURIComponent(String(proxyId)))
                .replace(`{${"databaseName"}}`, encodeURIComponent(String(databaseName)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exchange current state for a specific proxy instance
         * @summary Exchange latest proxy state
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {ExchangeProxyStateRequest} exchangeProxyStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIExchangeProxyState: async (organizationId: string, proxyId: string, exchangeProxyStateRequest: ExchangeProxyStateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cachingAPIExchangeProxyState', 'organizationId', organizationId)
            // verify required parameter 'proxyId' is not null or undefined
            assertParamExists('cachingAPIExchangeProxyState', 'proxyId', proxyId)
            // verify required parameter 'exchangeProxyStateRequest' is not null or undefined
            assertParamExists('cachingAPIExchangeProxyState', 'exchangeProxyStateRequest', exchangeProxyStateRequest)
            const localVarPath = `/database-optimizer/caching/v1alpha/organizations/{organizationId}/proxies/{proxyId}/state`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"proxyId"}}`, encodeURIComponent(String(proxyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exchangeProxyStateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get instance-level cache metrics timeseries for all databases behind a proxy.   Returns per-bucket cache hits/projection for every database, server-side ranked  top-N databases by cache hits over the range, and direct-mode transition events.
         * @summary Get instance-level cache metrics timeseries for a proxy
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} [startTime] Start of the reporting period
         * @param {string} [endTime] End of the reporting period
         * @param {number} [stepSeconds] Aggregate items in specified interval steps
         * @param {number} [topN] Maximum number of top databases to return, ranked by cache hits over the range. Defaults to 5
         * @param {string} [databaseId] Filter by logical database identifier. When unset, every database behind  the proxy is included.
         * @param {string} [username] Filter by username. When omitted, metrics for all users are aggregated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIGetInstanceProxyCacheMetrics: async (organizationId: string, proxyId: string, startTime?: string, endTime?: string, stepSeconds?: number, topN?: number, databaseId?: string, username?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cachingAPIGetInstanceProxyCacheMetrics', 'organizationId', organizationId)
            // verify required parameter 'proxyId' is not null or undefined
            assertParamExists('cachingAPIGetInstanceProxyCacheMetrics', 'proxyId', proxyId)
            const localVarPath = `/database-optimizer/caching/v1alpha/organizations/{organizationId}/proxies/{proxyId}/cache-metrics`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"proxyId"}}`, encodeURIComponent(String(proxyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (stepSeconds !== undefined) {
                localVarQueryParameter['stepSeconds'] = stepSeconds;
            }

            if (topN !== undefined) {
                localVarQueryParameter['topN'] = topN;
            }

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get cache metrics timeseries for a specific logical database behind a proxy.   Returns per-bucket metrics data, optionally filtered down to a single query template hash.
         * @summary Get cache metrics timeseries for a proxy database
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the logical database within the proxy
         * @param {string} [startTime] Start of the reporting period
         * @param {string} [endTime] End of the reporting period
         * @param {number} [stepSeconds] Aggregate items in specified interval steps
         * @param {string} [templateHash] Filter by template_hash
         * @param {string} [username] Filter by username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIGetProxyCacheMetrics: async (organizationId: string, proxyId: string, databaseName: string, startTime?: string, endTime?: string, stepSeconds?: number, templateHash?: string, username?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cachingAPIGetProxyCacheMetrics', 'organizationId', organizationId)
            // verify required parameter 'proxyId' is not null or undefined
            assertParamExists('cachingAPIGetProxyCacheMetrics', 'proxyId', proxyId)
            // verify required parameter 'databaseName' is not null or undefined
            assertParamExists('cachingAPIGetProxyCacheMetrics', 'databaseName', databaseName)
            const localVarPath = `/database-optimizer/caching/v1alpha/organizations/{organizationId}/proxies/{proxyId}/databases/{databaseName}/cache-metrics`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"proxyId"}}`, encodeURIComponent(String(proxyId)))
                .replace(`{${"databaseName"}}`, encodeURIComponent(String(databaseName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (stepSeconds !== undefined) {
                localVarQueryParameter['stepSeconds'] = stepSeconds;
            }

            if (templateHash !== undefined) {
                localVarQueryParameter['templateHash'] = templateHash;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get per-template query insights for a specific logical database behind a proxy.   Returns timeseries of query insights (cache miss latency percentiles, TTL bounds, unique query/result counts)  plus an aggregate summary over the requested period.
         * @summary Get cache query insights for a proxy database
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the logical database within the proxy
         * @param {string} templateHash Hash of the normalized SQL template
         * @param {string} [startTime] Start of the reporting period
         * @param {string} [endTime] End of the reporting period
         * @param {number} [stepSeconds] Aggregate items in specified interval steps
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIGetProxyCacheQueryInsights: async (organizationId: string, proxyId: string, databaseName: string, templateHash: string, startTime?: string, endTime?: string, stepSeconds?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cachingAPIGetProxyCacheQueryInsights', 'organizationId', organizationId)
            // verify required parameter 'proxyId' is not null or undefined
            assertParamExists('cachingAPIGetProxyCacheQueryInsights', 'proxyId', proxyId)
            // verify required parameter 'databaseName' is not null or undefined
            assertParamExists('cachingAPIGetProxyCacheQueryInsights', 'databaseName', databaseName)
            // verify required parameter 'templateHash' is not null or undefined
            assertParamExists('cachingAPIGetProxyCacheQueryInsights', 'templateHash', templateHash)
            const localVarPath = `/database-optimizer/caching/v1alpha/organizations/{organizationId}/proxies/{proxyId}/databases/{databaseName}/queries/{templateHash}/insights`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"proxyId"}}`, encodeURIComponent(String(proxyId)))
                .replace(`{${"databaseName"}}`, encodeURIComponent(String(databaseName)))
                .replace(`{${"templateHash"}}`, encodeURIComponent(String(templateHash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (stepSeconds !== undefined) {
                localVarQueryParameter['stepSeconds'] = stepSeconds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the normalized SQL template string for a specific template hash.
         * @summary Get cache query template for a proxy database
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the logical database within the proxy
         * @param {string} templateHash Hash of the normalized SQL template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIGetProxyCacheQueryTemplate: async (organizationId: string, proxyId: string, databaseName: string, templateHash: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cachingAPIGetProxyCacheQueryTemplate', 'organizationId', organizationId)
            // verify required parameter 'proxyId' is not null or undefined
            assertParamExists('cachingAPIGetProxyCacheQueryTemplate', 'proxyId', proxyId)
            // verify required parameter 'databaseName' is not null or undefined
            assertParamExists('cachingAPIGetProxyCacheQueryTemplate', 'databaseName', databaseName)
            // verify required parameter 'templateHash' is not null or undefined
            assertParamExists('cachingAPIGetProxyCacheQueryTemplate', 'templateHash', templateHash)
            const localVarPath = `/database-optimizer/caching/v1alpha/organizations/{organizationId}/proxies/{proxyId}/databases/{databaseName}/queries/{templateHash}/template`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"proxyId"}}`, encodeURIComponent(String(proxyId)))
                .replace(`{${"databaseName"}}`, encodeURIComponent(String(databaseName)))
                .replace(`{${"templateHash"}}`, encodeURIComponent(String(templateHash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an aggregated cache summary for a specific logical database behind a proxy.   Returns totals and rates (actual, projected, and optimal) over the requested period.
         * @summary Get cache summary for a proxy database
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the logical database within the proxy
         * @param {string} [startTime] Start of the reporting period
         * @param {string} [endTime] End of the reporting period
         * @param {string} [username] Filter by username
         * @param {string} [templateHash] Filter by template_hash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIGetProxyCacheSummary: async (organizationId: string, proxyId: string, databaseName: string, startTime?: string, endTime?: string, username?: string, templateHash?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cachingAPIGetProxyCacheSummary', 'organizationId', organizationId)
            // verify required parameter 'proxyId' is not null or undefined
            assertParamExists('cachingAPIGetProxyCacheSummary', 'proxyId', proxyId)
            // verify required parameter 'databaseName' is not null or undefined
            assertParamExists('cachingAPIGetProxyCacheSummary', 'databaseName', databaseName)
            const localVarPath = `/database-optimizer/caching/v1alpha/organizations/{organizationId}/proxies/{proxyId}/databases/{databaseName}/cache-summary`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"proxyId"}}`, encodeURIComponent(String(proxyId)))
                .replace(`{${"databaseName"}}`, encodeURIComponent(String(databaseName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (templateHash !== undefined) {
                localVarQueryParameter['templateHash'] = templateHash;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get connections timeseries for the databases behind a proxy.   Returns per-bucket connection usage summed across databases: the client  connections into DBO (incoming) alongside the connections DBO holds against  the upstream database (outgoing). Covers every database behind the proxy  unless narrowed with database_id.
         * @summary Get connections timeseries for a proxy
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} [startTime] Start of the reporting period
         * @param {string} [endTime] End of the reporting period
         * @param {number} [stepSeconds] Aggregate items in specified interval steps
         * @param {string} [databaseId] Filter by logical database identifier. When unset, every database behind  the proxy is included.
         * @param {string} [username] Filter by username. When omitted, metrics for all users are aggregated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIGetProxyConnectionsMetrics: async (organizationId: string, proxyId: string, startTime?: string, endTime?: string, stepSeconds?: number, databaseId?: string, username?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cachingAPIGetProxyConnectionsMetrics', 'organizationId', organizationId)
            // verify required parameter 'proxyId' is not null or undefined
            assertParamExists('cachingAPIGetProxyConnectionsMetrics', 'proxyId', proxyId)
            const localVarPath = `/database-optimizer/caching/v1alpha/organizations/{organizationId}/proxies/{proxyId}/connections-metrics`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"proxyId"}}`, encodeURIComponent(String(proxyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (stepSeconds !== undefined) {
                localVarQueryParameter['stepSeconds'] = stepSeconds;
            }

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get performance metrics timeseries for the databases behind a proxy.   Returns per-bucket query performance metrics (total statements, reads,  writes, execution-time percentiles) plus an aggregate summary over the  requested period. Covers every database behind the proxy unless narrowed  with database_id.
         * @summary Get performance metrics timeseries for a proxy
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} [startTime] Start of the reporting period
         * @param {string} [endTime] End of the reporting period
         * @param {number} [stepSeconds] Aggregate items in specified interval steps
         * @param {string} [databaseId] Filter by logical database identifier. When unset, every database behind the proxy is included.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIGetProxyPerformanceMetrics: async (organizationId: string, proxyId: string, startTime?: string, endTime?: string, stepSeconds?: number, databaseId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cachingAPIGetProxyPerformanceMetrics', 'organizationId', organizationId)
            // verify required parameter 'proxyId' is not null or undefined
            assertParamExists('cachingAPIGetProxyPerformanceMetrics', 'proxyId', proxyId)
            const localVarPath = `/database-optimizer/caching/v1alpha/organizations/{organizationId}/proxies/{proxyId}/performance-metrics`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"proxyId"}}`, encodeURIComponent(String(proxyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (stepSeconds !== undefined) {
                localVarQueryParameter['stepSeconds'] = stepSeconds;
            }

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List queries seen by the proxy for a specific logical database.   Returns per-template aggregated query statistics (cache hits, misses, execution times, etc.)  derived from proxy query metrics over the requested period.
         * @summary List queries seen by the proxy for a database
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the logical database within the proxy
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {CachingAPIGetProxyQueriesSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {string} [startTime] Start of the reporting period. Defaults to last 7 days if both start and end are unset.
         * @param {string} [endTime] End of the reporting period
         * @param {string} [queryContains] Optional substring filter on the normalized SQL template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIGetProxyQueries: async (organizationId: string, proxyId: string, databaseName: string, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: CachingAPIGetProxyQueriesSortOrderEnum, startTime?: string, endTime?: string, queryContains?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cachingAPIGetProxyQueries', 'organizationId', organizationId)
            // verify required parameter 'proxyId' is not null or undefined
            assertParamExists('cachingAPIGetProxyQueries', 'proxyId', proxyId)
            // verify required parameter 'databaseName' is not null or undefined
            assertParamExists('cachingAPIGetProxyQueries', 'databaseName', databaseName)
            const localVarPath = `/database-optimizer/caching/v1alpha/organizations/{organizationId}/proxies/{proxyId}/databases/{databaseName}/queries`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"proxyId"}}`, encodeURIComponent(String(proxyId)))
                .replace(`{${"databaseName"}}`, encodeURIComponent(String(databaseName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort.field'] = sortField;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort.order'] = sortOrder;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (queryContains !== undefined) {
                localVarQueryParameter['queryContains'] = queryContains;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List cache rules for a specific logical database behind a proxy.   Returns the per-table and per-query TTL override rules configured for the database.
         * @summary List cache rules for a proxy database
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the logical database within the proxy
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [table] Filter rules by table name. Returns only the rule for that table.
         * @param {string} [templateHash] Filter rules by normalized SQL template hash. Returns the query rule and any table rules for the tables the query touches.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIListCacheRules: async (organizationId: string, proxyId: string, databaseName: string, pageLimit?: string, pageCursor?: string, table?: string, templateHash?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cachingAPIListCacheRules', 'organizationId', organizationId)
            // verify required parameter 'proxyId' is not null or undefined
            assertParamExists('cachingAPIListCacheRules', 'proxyId', proxyId)
            // verify required parameter 'databaseName' is not null or undefined
            assertParamExists('cachingAPIListCacheRules', 'databaseName', databaseName)
            const localVarPath = `/database-optimizer/caching/v1alpha/organizations/{organizationId}/proxies/{proxyId}/databases/{databaseName}/rules`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"proxyId"}}`, encodeURIComponent(String(proxyId)))
                .replace(`{${"databaseName"}}`, encodeURIComponent(String(databaseName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (table !== undefined) {
                localVarQueryParameter['table'] = table;
            }

            if (templateHash !== undefined) {
                localVarQueryParameter['templateHash'] = templateHash;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Report operational metrics (connection pool gauges) from the proxy
         * @summary Report operational metrics from proxy
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {ReportOperationalMetricsRequest} reportOperationalMetricsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIReportOperationalMetrics: async (organizationId: string, proxyId: string, reportOperationalMetricsRequest: ReportOperationalMetricsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cachingAPIReportOperationalMetrics', 'organizationId', organizationId)
            // verify required parameter 'proxyId' is not null or undefined
            assertParamExists('cachingAPIReportOperationalMetrics', 'proxyId', proxyId)
            // verify required parameter 'reportOperationalMetricsRequest' is not null or undefined
            assertParamExists('cachingAPIReportOperationalMetrics', 'reportOperationalMetricsRequest', reportOperationalMetricsRequest)
            const localVarPath = `/database-optimizer/caching/v1alpha/organizations/{organizationId}/proxies/{proxyId}/operational-metrics`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"proxyId"}}`, encodeURIComponent(String(proxyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportOperationalMetricsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Report pooling metrics (connection pool gauges) from the pooler
         * @summary Report pooling metrics from the pooler
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {ReportPoolingMetricsRequest} reportPoolingMetricsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIReportPoolingMetrics: async (organizationId: string, proxyId: string, reportPoolingMetricsRequest: ReportPoolingMetricsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cachingAPIReportPoolingMetrics', 'organizationId', organizationId)
            // verify required parameter 'proxyId' is not null or undefined
            assertParamExists('cachingAPIReportPoolingMetrics', 'proxyId', proxyId)
            // verify required parameter 'reportPoolingMetricsRequest' is not null or undefined
            assertParamExists('cachingAPIReportPoolingMetrics', 'reportPoolingMetricsRequest', reportPoolingMetricsRequest)
            const localVarPath = `/database-optimizer/caching/v1alpha/organizations/{organizationId}/proxies/{proxyId}/pooling-metrics`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"proxyId"}}`, encodeURIComponent(String(proxyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportPoolingMetricsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Report a batch of query metrics from the proxy
         * @summary Report query metrics from proxy
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the database
         * @param {ReportQueryMetricsRequest} reportQueryMetricsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIReportQueryMetrics: async (organizationId: string, proxyId: string, databaseName: string, reportQueryMetricsRequest: ReportQueryMetricsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cachingAPIReportQueryMetrics', 'organizationId', organizationId)
            // verify required parameter 'proxyId' is not null or undefined
            assertParamExists('cachingAPIReportQueryMetrics', 'proxyId', proxyId)
            // verify required parameter 'databaseName' is not null or undefined
            assertParamExists('cachingAPIReportQueryMetrics', 'databaseName', databaseName)
            // verify required parameter 'reportQueryMetricsRequest' is not null or undefined
            assertParamExists('cachingAPIReportQueryMetrics', 'reportQueryMetricsRequest', reportQueryMetricsRequest)
            const localVarPath = `/database-optimizer/caching/v1alpha/organizations/{organizationId}/proxies/{proxyId}/databases/{databaseName}/query-metrics`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"proxyId"}}`, encodeURIComponent(String(proxyId)))
                .replace(`{${"databaseName"}}`, encodeURIComponent(String(databaseName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportQueryMetricsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a cache rule for a specific logical database behind a proxy.   Replaces the mutable fields of an existing rule. Output-only fields are ignored.
         * @summary Update a cache rule for a proxy database
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the logical database within the proxy
         * @param {string} id Cache rule identifier
         * @param {CacheRule} cacheRule 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIUpdateCacheRule: async (organizationId: string, proxyId: string, databaseName: string, id: string, cacheRule: CacheRule, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cachingAPIUpdateCacheRule', 'organizationId', organizationId)
            // verify required parameter 'proxyId' is not null or undefined
            assertParamExists('cachingAPIUpdateCacheRule', 'proxyId', proxyId)
            // verify required parameter 'databaseName' is not null or undefined
            assertParamExists('cachingAPIUpdateCacheRule', 'databaseName', databaseName)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cachingAPIUpdateCacheRule', 'id', id)
            // verify required parameter 'cacheRule' is not null or undefined
            assertParamExists('cachingAPIUpdateCacheRule', 'cacheRule', cacheRule)
            const localVarPath = `/database-optimizer/caching/v1alpha/organizations/{organizationId}/proxies/{proxyId}/databases/{databaseName}/rules/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"proxyId"}}`, encodeURIComponent(String(proxyId)))
                .replace(`{${"databaseName"}}`, encodeURIComponent(String(databaseName)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cacheRule, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a logical database behind a proxy   Only fields present in the request are updated;  omitted fields are left unchanged.
         * @summary Update a logical database behind a proxy
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the database
         * @param {ProxyDatabaseUpdate} proxyDatabaseUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIUpdateProxyDatabase: async (organizationId: string, proxyId: string, databaseName: string, proxyDatabaseUpdate: ProxyDatabaseUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cachingAPIUpdateProxyDatabase', 'organizationId', organizationId)
            // verify required parameter 'proxyId' is not null or undefined
            assertParamExists('cachingAPIUpdateProxyDatabase', 'proxyId', proxyId)
            // verify required parameter 'databaseName' is not null or undefined
            assertParamExists('cachingAPIUpdateProxyDatabase', 'databaseName', databaseName)
            // verify required parameter 'proxyDatabaseUpdate' is not null or undefined
            assertParamExists('cachingAPIUpdateProxyDatabase', 'proxyDatabaseUpdate', proxyDatabaseUpdate)
            const localVarPath = `/database-optimizer/caching/v1alpha/organizations/{organizationId}/proxies/{proxyId}/databases/{databaseName}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"proxyId"}}`, encodeURIComponent(String(proxyId)))
                .replace(`{${"databaseName"}}`, encodeURIComponent(String(databaseName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(proxyDatabaseUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CachingAPIApi - functional programming interface
 * @export
 */
export const CachingAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CachingAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a cache rule for a specific logical database behind a proxy.   Adds a per-table or per-query TTL override rule. Exactly one of table or  template_hash must be set on the rule.
         * @summary Create a cache rule for a proxy database
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the logical database within the proxy
         * @param {CacheRule} cacheRule 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cachingAPICreateCacheRule(organizationId: string, proxyId: string, databaseName: string, cacheRule: CacheRule, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CacheRule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cachingAPICreateCacheRule(organizationId, proxyId, databaseName, cacheRule, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CachingAPIApi.cachingAPICreateCacheRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a proxy for a database instance
         * @summary Create a proxy for a database instance
         * @param {string} organizationId Organization identifier
         * @param {Proxy} proxy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cachingAPICreateProxy(organizationId: string, proxy: Proxy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Proxy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cachingAPICreateProxy(organizationId, proxy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CachingAPIApi.cachingAPICreateProxy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a cache rule for a specific logical database behind a proxy.
         * @summary Delete a cache rule for a proxy database
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the logical database within the proxy
         * @param {string} id Cache rule identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cachingAPIDeleteCacheRule(organizationId: string, proxyId: string, databaseName: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cachingAPIDeleteCacheRule(organizationId, proxyId, databaseName, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CachingAPIApi.cachingAPIDeleteCacheRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exchange current state for a specific proxy instance
         * @summary Exchange latest proxy state
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {ExchangeProxyStateRequest} exchangeProxyStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cachingAPIExchangeProxyState(organizationId: string, proxyId: string, exchangeProxyStateRequest: ExchangeProxyStateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExchangeProxyStateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cachingAPIExchangeProxyState(organizationId, proxyId, exchangeProxyStateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CachingAPIApi.cachingAPIExchangeProxyState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get instance-level cache metrics timeseries for all databases behind a proxy.   Returns per-bucket cache hits/projection for every database, server-side ranked  top-N databases by cache hits over the range, and direct-mode transition events.
         * @summary Get instance-level cache metrics timeseries for a proxy
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} [startTime] Start of the reporting period
         * @param {string} [endTime] End of the reporting period
         * @param {number} [stepSeconds] Aggregate items in specified interval steps
         * @param {number} [topN] Maximum number of top databases to return, ranked by cache hits over the range. Defaults to 5
         * @param {string} [databaseId] Filter by logical database identifier. When unset, every database behind  the proxy is included.
         * @param {string} [username] Filter by username. When omitted, metrics for all users are aggregated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cachingAPIGetInstanceProxyCacheMetrics(organizationId: string, proxyId: string, startTime?: string, endTime?: string, stepSeconds?: number, topN?: number, databaseId?: string, username?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInstanceProxyCacheMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cachingAPIGetInstanceProxyCacheMetrics(organizationId, proxyId, startTime, endTime, stepSeconds, topN, databaseId, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CachingAPIApi.cachingAPIGetInstanceProxyCacheMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get cache metrics timeseries for a specific logical database behind a proxy.   Returns per-bucket metrics data, optionally filtered down to a single query template hash.
         * @summary Get cache metrics timeseries for a proxy database
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the logical database within the proxy
         * @param {string} [startTime] Start of the reporting period
         * @param {string} [endTime] End of the reporting period
         * @param {number} [stepSeconds] Aggregate items in specified interval steps
         * @param {string} [templateHash] Filter by template_hash
         * @param {string} [username] Filter by username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cachingAPIGetProxyCacheMetrics(organizationId: string, proxyId: string, databaseName: string, startTime?: string, endTime?: string, stepSeconds?: number, templateHash?: string, username?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCacheMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cachingAPIGetProxyCacheMetrics(organizationId, proxyId, databaseName, startTime, endTime, stepSeconds, templateHash, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CachingAPIApi.cachingAPIGetProxyCacheMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get per-template query insights for a specific logical database behind a proxy.   Returns timeseries of query insights (cache miss latency percentiles, TTL bounds, unique query/result counts)  plus an aggregate summary over the requested period.
         * @summary Get cache query insights for a proxy database
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the logical database within the proxy
         * @param {string} templateHash Hash of the normalized SQL template
         * @param {string} [startTime] Start of the reporting period
         * @param {string} [endTime] End of the reporting period
         * @param {number} [stepSeconds] Aggregate items in specified interval steps
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cachingAPIGetProxyCacheQueryInsights(organizationId: string, proxyId: string, databaseName: string, templateHash: string, startTime?: string, endTime?: string, stepSeconds?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCacheQueryInsightsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cachingAPIGetProxyCacheQueryInsights(organizationId, proxyId, databaseName, templateHash, startTime, endTime, stepSeconds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CachingAPIApi.cachingAPIGetProxyCacheQueryInsights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the normalized SQL template string for a specific template hash.
         * @summary Get cache query template for a proxy database
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the logical database within the proxy
         * @param {string} templateHash Hash of the normalized SQL template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cachingAPIGetProxyCacheQueryTemplate(organizationId: string, proxyId: string, databaseName: string, templateHash: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCacheQueryTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cachingAPIGetProxyCacheQueryTemplate(organizationId, proxyId, databaseName, templateHash, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CachingAPIApi.cachingAPIGetProxyCacheQueryTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get an aggregated cache summary for a specific logical database behind a proxy.   Returns totals and rates (actual, projected, and optimal) over the requested period.
         * @summary Get cache summary for a proxy database
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the logical database within the proxy
         * @param {string} [startTime] Start of the reporting period
         * @param {string} [endTime] End of the reporting period
         * @param {string} [username] Filter by username
         * @param {string} [templateHash] Filter by template_hash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cachingAPIGetProxyCacheSummary(organizationId: string, proxyId: string, databaseName: string, startTime?: string, endTime?: string, username?: string, templateHash?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCacheSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cachingAPIGetProxyCacheSummary(organizationId, proxyId, databaseName, startTime, endTime, username, templateHash, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CachingAPIApi.cachingAPIGetProxyCacheSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get connections timeseries for the databases behind a proxy.   Returns per-bucket connection usage summed across databases: the client  connections into DBO (incoming) alongside the connections DBO holds against  the upstream database (outgoing). Covers every database behind the proxy  unless narrowed with database_id.
         * @summary Get connections timeseries for a proxy
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} [startTime] Start of the reporting period
         * @param {string} [endTime] End of the reporting period
         * @param {number} [stepSeconds] Aggregate items in specified interval steps
         * @param {string} [databaseId] Filter by logical database identifier. When unset, every database behind  the proxy is included.
         * @param {string} [username] Filter by username. When omitted, metrics for all users are aggregated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cachingAPIGetProxyConnectionsMetrics(organizationId: string, proxyId: string, startTime?: string, endTime?: string, stepSeconds?: number, databaseId?: string, username?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetConnectionsMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cachingAPIGetProxyConnectionsMetrics(organizationId, proxyId, startTime, endTime, stepSeconds, databaseId, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CachingAPIApi.cachingAPIGetProxyConnectionsMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get performance metrics timeseries for the databases behind a proxy.   Returns per-bucket query performance metrics (total statements, reads,  writes, execution-time percentiles) plus an aggregate summary over the  requested period. Covers every database behind the proxy unless narrowed  with database_id.
         * @summary Get performance metrics timeseries for a proxy
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} [startTime] Start of the reporting period
         * @param {string} [endTime] End of the reporting period
         * @param {number} [stepSeconds] Aggregate items in specified interval steps
         * @param {string} [databaseId] Filter by logical database identifier. When unset, every database behind the proxy is included.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cachingAPIGetProxyPerformanceMetrics(organizationId: string, proxyId: string, startTime?: string, endTime?: string, stepSeconds?: number, databaseId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPerformanceMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cachingAPIGetProxyPerformanceMetrics(organizationId, proxyId, startTime, endTime, stepSeconds, databaseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CachingAPIApi.cachingAPIGetProxyPerformanceMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List queries seen by the proxy for a specific logical database.   Returns per-template aggregated query statistics (cache hits, misses, execution times, etc.)  derived from proxy query metrics over the requested period.
         * @summary List queries seen by the proxy for a database
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the logical database within the proxy
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {CachingAPIGetProxyQueriesSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {string} [startTime] Start of the reporting period. Defaults to last 7 days if both start and end are unset.
         * @param {string} [endTime] End of the reporting period
         * @param {string} [queryContains] Optional substring filter on the normalized SQL template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cachingAPIGetProxyQueries(organizationId: string, proxyId: string, databaseName: string, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: CachingAPIGetProxyQueriesSortOrderEnum, startTime?: string, endTime?: string, queryContains?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProxyQueriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cachingAPIGetProxyQueries(organizationId, proxyId, databaseName, pageLimit, pageCursor, sortField, sortOrder, startTime, endTime, queryContains, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CachingAPIApi.cachingAPIGetProxyQueries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List cache rules for a specific logical database behind a proxy.   Returns the per-table and per-query TTL override rules configured for the database.
         * @summary List cache rules for a proxy database
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the logical database within the proxy
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [table] Filter rules by table name. Returns only the rule for that table.
         * @param {string} [templateHash] Filter rules by normalized SQL template hash. Returns the query rule and any table rules for the tables the query touches.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cachingAPIListCacheRules(organizationId: string, proxyId: string, databaseName: string, pageLimit?: string, pageCursor?: string, table?: string, templateHash?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCacheRulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cachingAPIListCacheRules(organizationId, proxyId, databaseName, pageLimit, pageCursor, table, templateHash, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CachingAPIApi.cachingAPIListCacheRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Report operational metrics (connection pool gauges) from the proxy
         * @summary Report operational metrics from proxy
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {ReportOperationalMetricsRequest} reportOperationalMetricsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cachingAPIReportOperationalMetrics(organizationId: string, proxyId: string, reportOperationalMetricsRequest: ReportOperationalMetricsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cachingAPIReportOperationalMetrics(organizationId, proxyId, reportOperationalMetricsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CachingAPIApi.cachingAPIReportOperationalMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Report pooling metrics (connection pool gauges) from the pooler
         * @summary Report pooling metrics from the pooler
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {ReportPoolingMetricsRequest} reportPoolingMetricsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cachingAPIReportPoolingMetrics(organizationId: string, proxyId: string, reportPoolingMetricsRequest: ReportPoolingMetricsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cachingAPIReportPoolingMetrics(organizationId, proxyId, reportPoolingMetricsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CachingAPIApi.cachingAPIReportPoolingMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Report a batch of query metrics from the proxy
         * @summary Report query metrics from proxy
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the database
         * @param {ReportQueryMetricsRequest} reportQueryMetricsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cachingAPIReportQueryMetrics(organizationId: string, proxyId: string, databaseName: string, reportQueryMetricsRequest: ReportQueryMetricsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cachingAPIReportQueryMetrics(organizationId, proxyId, databaseName, reportQueryMetricsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CachingAPIApi.cachingAPIReportQueryMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a cache rule for a specific logical database behind a proxy.   Replaces the mutable fields of an existing rule. Output-only fields are ignored.
         * @summary Update a cache rule for a proxy database
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the logical database within the proxy
         * @param {string} id Cache rule identifier
         * @param {CacheRule} cacheRule 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cachingAPIUpdateCacheRule(organizationId: string, proxyId: string, databaseName: string, id: string, cacheRule: CacheRule, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CacheRule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cachingAPIUpdateCacheRule(organizationId, proxyId, databaseName, id, cacheRule, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CachingAPIApi.cachingAPIUpdateCacheRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a logical database behind a proxy   Only fields present in the request are updated;  omitted fields are left unchanged.
         * @summary Update a logical database behind a proxy
         * @param {string} organizationId Organization identifier
         * @param {string} proxyId Proxy identifier
         * @param {string} databaseName Name of the database
         * @param {ProxyDatabaseUpdate} proxyDatabaseUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cachingAPIUpdateProxyDatabase(organizationId: string, proxyId: string, databaseName: string, proxyDatabaseUpdate: ProxyDatabaseUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProxyLogicalDatabaseConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cachingAPIUpdateProxyDatabase(organizationId, proxyId, databaseName, proxyDatabaseUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CachingAPIApi.cachingAPIUpdateProxyDatabase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CachingAPIApi - factory interface
 * @export
 */
export const CachingAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CachingAPIApiFp(configuration)
    return {
        /**
         * Create a cache rule for a specific logical database behind a proxy.   Adds a per-table or per-query TTL override rule. Exactly one of table or  template_hash must be set on the rule.
         * @summary Create a cache rule for a proxy database
         * @param {CachingAPIApiCachingAPICreateCacheRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPICreateCacheRule(requestParameters: CachingAPIApiCachingAPICreateCacheRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<CacheRule> {
            return localVarFp.cachingAPICreateCacheRule(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.cacheRule, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a proxy for a database instance
         * @summary Create a proxy for a database instance
         * @param {CachingAPIApiCachingAPICreateProxyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPICreateProxy(requestParameters: CachingAPIApiCachingAPICreateProxyRequest, options?: RawAxiosRequestConfig): AxiosPromise<Proxy> {
            return localVarFp.cachingAPICreateProxy(requestParameters.organizationId, requestParameters.proxy, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a cache rule for a specific logical database behind a proxy.
         * @summary Delete a cache rule for a proxy database
         * @param {CachingAPIApiCachingAPIDeleteCacheRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIDeleteCacheRule(requestParameters: CachingAPIApiCachingAPIDeleteCacheRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cachingAPIDeleteCacheRule(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Exchange current state for a specific proxy instance
         * @summary Exchange latest proxy state
         * @param {CachingAPIApiCachingAPIExchangeProxyStateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIExchangeProxyState(requestParameters: CachingAPIApiCachingAPIExchangeProxyStateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExchangeProxyStateResponse> {
            return localVarFp.cachingAPIExchangeProxyState(requestParameters.organizationId, requestParameters.proxyId, requestParameters.exchangeProxyStateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get instance-level cache metrics timeseries for all databases behind a proxy.   Returns per-bucket cache hits/projection for every database, server-side ranked  top-N databases by cache hits over the range, and direct-mode transition events.
         * @summary Get instance-level cache metrics timeseries for a proxy
         * @param {CachingAPIApiCachingAPIGetInstanceProxyCacheMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIGetInstanceProxyCacheMetrics(requestParameters: CachingAPIApiCachingAPIGetInstanceProxyCacheMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetInstanceProxyCacheMetricsResponse> {
            return localVarFp.cachingAPIGetInstanceProxyCacheMetrics(requestParameters.organizationId, requestParameters.proxyId, requestParameters.startTime, requestParameters.endTime, requestParameters.stepSeconds, requestParameters.topN, requestParameters.databaseId, requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         * Get cache metrics timeseries for a specific logical database behind a proxy.   Returns per-bucket metrics data, optionally filtered down to a single query template hash.
         * @summary Get cache metrics timeseries for a proxy database
         * @param {CachingAPIApiCachingAPIGetProxyCacheMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIGetProxyCacheMetrics(requestParameters: CachingAPIApiCachingAPIGetProxyCacheMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCacheMetricsResponse> {
            return localVarFp.cachingAPIGetProxyCacheMetrics(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.startTime, requestParameters.endTime, requestParameters.stepSeconds, requestParameters.templateHash, requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         * Get per-template query insights for a specific logical database behind a proxy.   Returns timeseries of query insights (cache miss latency percentiles, TTL bounds, unique query/result counts)  plus an aggregate summary over the requested period.
         * @summary Get cache query insights for a proxy database
         * @param {CachingAPIApiCachingAPIGetProxyCacheQueryInsightsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIGetProxyCacheQueryInsights(requestParameters: CachingAPIApiCachingAPIGetProxyCacheQueryInsightsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCacheQueryInsightsResponse> {
            return localVarFp.cachingAPIGetProxyCacheQueryInsights(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.templateHash, requestParameters.startTime, requestParameters.endTime, requestParameters.stepSeconds, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the normalized SQL template string for a specific template hash.
         * @summary Get cache query template for a proxy database
         * @param {CachingAPIApiCachingAPIGetProxyCacheQueryTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIGetProxyCacheQueryTemplate(requestParameters: CachingAPIApiCachingAPIGetProxyCacheQueryTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCacheQueryTemplateResponse> {
            return localVarFp.cachingAPIGetProxyCacheQueryTemplate(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.templateHash, options).then((request) => request(axios, basePath));
        },
        /**
         * Get an aggregated cache summary for a specific logical database behind a proxy.   Returns totals and rates (actual, projected, and optimal) over the requested period.
         * @summary Get cache summary for a proxy database
         * @param {CachingAPIApiCachingAPIGetProxyCacheSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIGetProxyCacheSummary(requestParameters: CachingAPIApiCachingAPIGetProxyCacheSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCacheSummaryResponse> {
            return localVarFp.cachingAPIGetProxyCacheSummary(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.startTime, requestParameters.endTime, requestParameters.username, requestParameters.templateHash, options).then((request) => request(axios, basePath));
        },
        /**
         * Get connections timeseries for the databases behind a proxy.   Returns per-bucket connection usage summed across databases: the client  connections into DBO (incoming) alongside the connections DBO holds against  the upstream database (outgoing). Covers every database behind the proxy  unless narrowed with database_id.
         * @summary Get connections timeseries for a proxy
         * @param {CachingAPIApiCachingAPIGetProxyConnectionsMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIGetProxyConnectionsMetrics(requestParameters: CachingAPIApiCachingAPIGetProxyConnectionsMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetConnectionsMetricsResponse> {
            return localVarFp.cachingAPIGetProxyConnectionsMetrics(requestParameters.organizationId, requestParameters.proxyId, requestParameters.startTime, requestParameters.endTime, requestParameters.stepSeconds, requestParameters.databaseId, requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         * Get performance metrics timeseries for the databases behind a proxy.   Returns per-bucket query performance metrics (total statements, reads,  writes, execution-time percentiles) plus an aggregate summary over the  requested period. Covers every database behind the proxy unless narrowed  with database_id.
         * @summary Get performance metrics timeseries for a proxy
         * @param {CachingAPIApiCachingAPIGetProxyPerformanceMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIGetProxyPerformanceMetrics(requestParameters: CachingAPIApiCachingAPIGetProxyPerformanceMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPerformanceMetricsResponse> {
            return localVarFp.cachingAPIGetProxyPerformanceMetrics(requestParameters.organizationId, requestParameters.proxyId, requestParameters.startTime, requestParameters.endTime, requestParameters.stepSeconds, requestParameters.databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * List queries seen by the proxy for a specific logical database.   Returns per-template aggregated query statistics (cache hits, misses, execution times, etc.)  derived from proxy query metrics over the requested period.
         * @summary List queries seen by the proxy for a database
         * @param {CachingAPIApiCachingAPIGetProxyQueriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIGetProxyQueries(requestParameters: CachingAPIApiCachingAPIGetProxyQueriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetProxyQueriesResponse> {
            return localVarFp.cachingAPIGetProxyQueries(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, requestParameters.startTime, requestParameters.endTime, requestParameters.queryContains, options).then((request) => request(axios, basePath));
        },
        /**
         * List cache rules for a specific logical database behind a proxy.   Returns the per-table and per-query TTL override rules configured for the database.
         * @summary List cache rules for a proxy database
         * @param {CachingAPIApiCachingAPIListCacheRulesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIListCacheRules(requestParameters: CachingAPIApiCachingAPIListCacheRulesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListCacheRulesResponse> {
            return localVarFp.cachingAPIListCacheRules(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.table, requestParameters.templateHash, options).then((request) => request(axios, basePath));
        },
        /**
         * Report operational metrics (connection pool gauges) from the proxy
         * @summary Report operational metrics from proxy
         * @param {CachingAPIApiCachingAPIReportOperationalMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIReportOperationalMetrics(requestParameters: CachingAPIApiCachingAPIReportOperationalMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.cachingAPIReportOperationalMetrics(requestParameters.organizationId, requestParameters.proxyId, requestParameters.reportOperationalMetricsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Report pooling metrics (connection pool gauges) from the pooler
         * @summary Report pooling metrics from the pooler
         * @param {CachingAPIApiCachingAPIReportPoolingMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIReportPoolingMetrics(requestParameters: CachingAPIApiCachingAPIReportPoolingMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.cachingAPIReportPoolingMetrics(requestParameters.organizationId, requestParameters.proxyId, requestParameters.reportPoolingMetricsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Report a batch of query metrics from the proxy
         * @summary Report query metrics from proxy
         * @param {CachingAPIApiCachingAPIReportQueryMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIReportQueryMetrics(requestParameters: CachingAPIApiCachingAPIReportQueryMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.cachingAPIReportQueryMetrics(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.reportQueryMetricsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a cache rule for a specific logical database behind a proxy.   Replaces the mutable fields of an existing rule. Output-only fields are ignored.
         * @summary Update a cache rule for a proxy database
         * @param {CachingAPIApiCachingAPIUpdateCacheRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIUpdateCacheRule(requestParameters: CachingAPIApiCachingAPIUpdateCacheRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<CacheRule> {
            return localVarFp.cachingAPIUpdateCacheRule(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.id, requestParameters.cacheRule, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a logical database behind a proxy   Only fields present in the request are updated;  omitted fields are left unchanged.
         * @summary Update a logical database behind a proxy
         * @param {CachingAPIApiCachingAPIUpdateProxyDatabaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cachingAPIUpdateProxyDatabase(requestParameters: CachingAPIApiCachingAPIUpdateProxyDatabaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProxyLogicalDatabaseConfig> {
            return localVarFp.cachingAPIUpdateProxyDatabase(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.proxyDatabaseUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cachingAPICreateCacheRule operation in CachingAPIApi.
 * @export
 * @interface CachingAPIApiCachingAPICreateCacheRuleRequest
 */
export interface CachingAPIApiCachingAPICreateCacheRuleRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPICreateCacheRule
     */
    readonly organizationId: string

    /**
     * Proxy identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPICreateCacheRule
     */
    readonly proxyId: string

    /**
     * Name of the logical database within the proxy
     * @type {string}
     * @memberof CachingAPIApiCachingAPICreateCacheRule
     */
    readonly databaseName: string

    /**
     * 
     * @type {CacheRule}
     * @memberof CachingAPIApiCachingAPICreateCacheRule
     */
    readonly cacheRule: CacheRule
}

/**
 * Request parameters for cachingAPICreateProxy operation in CachingAPIApi.
 * @export
 * @interface CachingAPIApiCachingAPICreateProxyRequest
 */
export interface CachingAPIApiCachingAPICreateProxyRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPICreateProxy
     */
    readonly organizationId: string

    /**
     * 
     * @type {Proxy}
     * @memberof CachingAPIApiCachingAPICreateProxy
     */
    readonly proxy: Proxy
}

/**
 * Request parameters for cachingAPIDeleteCacheRule operation in CachingAPIApi.
 * @export
 * @interface CachingAPIApiCachingAPIDeleteCacheRuleRequest
 */
export interface CachingAPIApiCachingAPIDeleteCacheRuleRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIDeleteCacheRule
     */
    readonly organizationId: string

    /**
     * Proxy identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIDeleteCacheRule
     */
    readonly proxyId: string

    /**
     * Name of the logical database within the proxy
     * @type {string}
     * @memberof CachingAPIApiCachingAPIDeleteCacheRule
     */
    readonly databaseName: string

    /**
     * Cache rule identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIDeleteCacheRule
     */
    readonly id: string
}

/**
 * Request parameters for cachingAPIExchangeProxyState operation in CachingAPIApi.
 * @export
 * @interface CachingAPIApiCachingAPIExchangeProxyStateRequest
 */
export interface CachingAPIApiCachingAPIExchangeProxyStateRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIExchangeProxyState
     */
    readonly organizationId: string

    /**
     * Proxy identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIExchangeProxyState
     */
    readonly proxyId: string

    /**
     * 
     * @type {ExchangeProxyStateRequest}
     * @memberof CachingAPIApiCachingAPIExchangeProxyState
     */
    readonly exchangeProxyStateRequest: ExchangeProxyStateRequest
}

/**
 * Request parameters for cachingAPIGetInstanceProxyCacheMetrics operation in CachingAPIApi.
 * @export
 * @interface CachingAPIApiCachingAPIGetInstanceProxyCacheMetricsRequest
 */
export interface CachingAPIApiCachingAPIGetInstanceProxyCacheMetricsRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetInstanceProxyCacheMetrics
     */
    readonly organizationId: string

    /**
     * Proxy identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetInstanceProxyCacheMetrics
     */
    readonly proxyId: string

    /**
     * Start of the reporting period
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetInstanceProxyCacheMetrics
     */
    readonly startTime?: string

    /**
     * End of the reporting period
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetInstanceProxyCacheMetrics
     */
    readonly endTime?: string

    /**
     * Aggregate items in specified interval steps
     * @type {number}
     * @memberof CachingAPIApiCachingAPIGetInstanceProxyCacheMetrics
     */
    readonly stepSeconds?: number

    /**
     * Maximum number of top databases to return, ranked by cache hits over the range. Defaults to 5
     * @type {number}
     * @memberof CachingAPIApiCachingAPIGetInstanceProxyCacheMetrics
     */
    readonly topN?: number

    /**
     * Filter by logical database identifier. When unset, every database behind  the proxy is included.
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetInstanceProxyCacheMetrics
     */
    readonly databaseId?: string

    /**
     * Filter by username. When omitted, metrics for all users are aggregated.
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetInstanceProxyCacheMetrics
     */
    readonly username?: string
}

/**
 * Request parameters for cachingAPIGetProxyCacheMetrics operation in CachingAPIApi.
 * @export
 * @interface CachingAPIApiCachingAPIGetProxyCacheMetricsRequest
 */
export interface CachingAPIApiCachingAPIGetProxyCacheMetricsRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheMetrics
     */
    readonly organizationId: string

    /**
     * Proxy identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheMetrics
     */
    readonly proxyId: string

    /**
     * Name of the logical database within the proxy
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheMetrics
     */
    readonly databaseName: string

    /**
     * Start of the reporting period
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheMetrics
     */
    readonly startTime?: string

    /**
     * End of the reporting period
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheMetrics
     */
    readonly endTime?: string

    /**
     * Aggregate items in specified interval steps
     * @type {number}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheMetrics
     */
    readonly stepSeconds?: number

    /**
     * Filter by template_hash
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheMetrics
     */
    readonly templateHash?: string

    /**
     * Filter by username
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheMetrics
     */
    readonly username?: string
}

/**
 * Request parameters for cachingAPIGetProxyCacheQueryInsights operation in CachingAPIApi.
 * @export
 * @interface CachingAPIApiCachingAPIGetProxyCacheQueryInsightsRequest
 */
export interface CachingAPIApiCachingAPIGetProxyCacheQueryInsightsRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheQueryInsights
     */
    readonly organizationId: string

    /**
     * Proxy identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheQueryInsights
     */
    readonly proxyId: string

    /**
     * Name of the logical database within the proxy
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheQueryInsights
     */
    readonly databaseName: string

    /**
     * Hash of the normalized SQL template
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheQueryInsights
     */
    readonly templateHash: string

    /**
     * Start of the reporting period
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheQueryInsights
     */
    readonly startTime?: string

    /**
     * End of the reporting period
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheQueryInsights
     */
    readonly endTime?: string

    /**
     * Aggregate items in specified interval steps
     * @type {number}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheQueryInsights
     */
    readonly stepSeconds?: number
}

/**
 * Request parameters for cachingAPIGetProxyCacheQueryTemplate operation in CachingAPIApi.
 * @export
 * @interface CachingAPIApiCachingAPIGetProxyCacheQueryTemplateRequest
 */
export interface CachingAPIApiCachingAPIGetProxyCacheQueryTemplateRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheQueryTemplate
     */
    readonly organizationId: string

    /**
     * Proxy identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheQueryTemplate
     */
    readonly proxyId: string

    /**
     * Name of the logical database within the proxy
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheQueryTemplate
     */
    readonly databaseName: string

    /**
     * Hash of the normalized SQL template
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheQueryTemplate
     */
    readonly templateHash: string
}

/**
 * Request parameters for cachingAPIGetProxyCacheSummary operation in CachingAPIApi.
 * @export
 * @interface CachingAPIApiCachingAPIGetProxyCacheSummaryRequest
 */
export interface CachingAPIApiCachingAPIGetProxyCacheSummaryRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheSummary
     */
    readonly organizationId: string

    /**
     * Proxy identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheSummary
     */
    readonly proxyId: string

    /**
     * Name of the logical database within the proxy
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheSummary
     */
    readonly databaseName: string

    /**
     * Start of the reporting period
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheSummary
     */
    readonly startTime?: string

    /**
     * End of the reporting period
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheSummary
     */
    readonly endTime?: string

    /**
     * Filter by username
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheSummary
     */
    readonly username?: string

    /**
     * Filter by template_hash
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyCacheSummary
     */
    readonly templateHash?: string
}

/**
 * Request parameters for cachingAPIGetProxyConnectionsMetrics operation in CachingAPIApi.
 * @export
 * @interface CachingAPIApiCachingAPIGetProxyConnectionsMetricsRequest
 */
export interface CachingAPIApiCachingAPIGetProxyConnectionsMetricsRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyConnectionsMetrics
     */
    readonly organizationId: string

    /**
     * Proxy identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyConnectionsMetrics
     */
    readonly proxyId: string

    /**
     * Start of the reporting period
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyConnectionsMetrics
     */
    readonly startTime?: string

    /**
     * End of the reporting period
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyConnectionsMetrics
     */
    readonly endTime?: string

    /**
     * Aggregate items in specified interval steps
     * @type {number}
     * @memberof CachingAPIApiCachingAPIGetProxyConnectionsMetrics
     */
    readonly stepSeconds?: number

    /**
     * Filter by logical database identifier. When unset, every database behind  the proxy is included.
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyConnectionsMetrics
     */
    readonly databaseId?: string

    /**
     * Filter by username. When omitted, metrics for all users are aggregated.
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyConnectionsMetrics
     */
    readonly username?: string
}

/**
 * Request parameters for cachingAPIGetProxyPerformanceMetrics operation in CachingAPIApi.
 * @export
 * @interface CachingAPIApiCachingAPIGetProxyPerformanceMetricsRequest
 */
export interface CachingAPIApiCachingAPIGetProxyPerformanceMetricsRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyPerformanceMetrics
     */
    readonly organizationId: string

    /**
     * Proxy identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyPerformanceMetrics
     */
    readonly proxyId: string

    /**
     * Start of the reporting period
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyPerformanceMetrics
     */
    readonly startTime?: string

    /**
     * End of the reporting period
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyPerformanceMetrics
     */
    readonly endTime?: string

    /**
     * Aggregate items in specified interval steps
     * @type {number}
     * @memberof CachingAPIApiCachingAPIGetProxyPerformanceMetrics
     */
    readonly stepSeconds?: number

    /**
     * Filter by logical database identifier. When unset, every database behind the proxy is included.
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyPerformanceMetrics
     */
    readonly databaseId?: string
}

/**
 * Request parameters for cachingAPIGetProxyQueries operation in CachingAPIApi.
 * @export
 * @interface CachingAPIApiCachingAPIGetProxyQueriesRequest
 */
export interface CachingAPIApiCachingAPIGetProxyQueriesRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyQueries
     */
    readonly organizationId: string

    /**
     * Proxy identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyQueries
     */
    readonly proxyId: string

    /**
     * Name of the logical database within the proxy
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyQueries
     */
    readonly databaseName: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyQueries
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyQueries
     */
    readonly pageCursor?: string

    /**
     * The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyQueries
     */
    readonly sortField?: string

    /**
     * The order of returned items. Default is ASC.
     * @type {'ASC' | 'asc' | 'DESC' | 'desc'}
     * @memberof CachingAPIApiCachingAPIGetProxyQueries
     */
    readonly sortOrder?: CachingAPIGetProxyQueriesSortOrderEnum

    /**
     * Start of the reporting period. Defaults to last 7 days if both start and end are unset.
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyQueries
     */
    readonly startTime?: string

    /**
     * End of the reporting period
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyQueries
     */
    readonly endTime?: string

    /**
     * Optional substring filter on the normalized SQL template
     * @type {string}
     * @memberof CachingAPIApiCachingAPIGetProxyQueries
     */
    readonly queryContains?: string
}

/**
 * Request parameters for cachingAPIListCacheRules operation in CachingAPIApi.
 * @export
 * @interface CachingAPIApiCachingAPIListCacheRulesRequest
 */
export interface CachingAPIApiCachingAPIListCacheRulesRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIListCacheRules
     */
    readonly organizationId: string

    /**
     * Proxy identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIListCacheRules
     */
    readonly proxyId: string

    /**
     * Name of the logical database within the proxy
     * @type {string}
     * @memberof CachingAPIApiCachingAPIListCacheRules
     */
    readonly databaseName: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof CachingAPIApiCachingAPIListCacheRules
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof CachingAPIApiCachingAPIListCacheRules
     */
    readonly pageCursor?: string

    /**
     * Filter rules by table name. Returns only the rule for that table.
     * @type {string}
     * @memberof CachingAPIApiCachingAPIListCacheRules
     */
    readonly table?: string

    /**
     * Filter rules by normalized SQL template hash. Returns the query rule and any table rules for the tables the query touches.
     * @type {string}
     * @memberof CachingAPIApiCachingAPIListCacheRules
     */
    readonly templateHash?: string
}

/**
 * Request parameters for cachingAPIReportOperationalMetrics operation in CachingAPIApi.
 * @export
 * @interface CachingAPIApiCachingAPIReportOperationalMetricsRequest
 */
export interface CachingAPIApiCachingAPIReportOperationalMetricsRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIReportOperationalMetrics
     */
    readonly organizationId: string

    /**
     * Proxy identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIReportOperationalMetrics
     */
    readonly proxyId: string

    /**
     * 
     * @type {ReportOperationalMetricsRequest}
     * @memberof CachingAPIApiCachingAPIReportOperationalMetrics
     */
    readonly reportOperationalMetricsRequest: ReportOperationalMetricsRequest
}

/**
 * Request parameters for cachingAPIReportPoolingMetrics operation in CachingAPIApi.
 * @export
 * @interface CachingAPIApiCachingAPIReportPoolingMetricsRequest
 */
export interface CachingAPIApiCachingAPIReportPoolingMetricsRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIReportPoolingMetrics
     */
    readonly organizationId: string

    /**
     * Proxy identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIReportPoolingMetrics
     */
    readonly proxyId: string

    /**
     * 
     * @type {ReportPoolingMetricsRequest}
     * @memberof CachingAPIApiCachingAPIReportPoolingMetrics
     */
    readonly reportPoolingMetricsRequest: ReportPoolingMetricsRequest
}

/**
 * Request parameters for cachingAPIReportQueryMetrics operation in CachingAPIApi.
 * @export
 * @interface CachingAPIApiCachingAPIReportQueryMetricsRequest
 */
export interface CachingAPIApiCachingAPIReportQueryMetricsRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIReportQueryMetrics
     */
    readonly organizationId: string

    /**
     * Proxy identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIReportQueryMetrics
     */
    readonly proxyId: string

    /**
     * Name of the database
     * @type {string}
     * @memberof CachingAPIApiCachingAPIReportQueryMetrics
     */
    readonly databaseName: string

    /**
     * 
     * @type {ReportQueryMetricsRequest}
     * @memberof CachingAPIApiCachingAPIReportQueryMetrics
     */
    readonly reportQueryMetricsRequest: ReportQueryMetricsRequest
}

/**
 * Request parameters for cachingAPIUpdateCacheRule operation in CachingAPIApi.
 * @export
 * @interface CachingAPIApiCachingAPIUpdateCacheRuleRequest
 */
export interface CachingAPIApiCachingAPIUpdateCacheRuleRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIUpdateCacheRule
     */
    readonly organizationId: string

    /**
     * Proxy identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIUpdateCacheRule
     */
    readonly proxyId: string

    /**
     * Name of the logical database within the proxy
     * @type {string}
     * @memberof CachingAPIApiCachingAPIUpdateCacheRule
     */
    readonly databaseName: string

    /**
     * Cache rule identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIUpdateCacheRule
     */
    readonly id: string

    /**
     * 
     * @type {CacheRule}
     * @memberof CachingAPIApiCachingAPIUpdateCacheRule
     */
    readonly cacheRule: CacheRule
}

/**
 * Request parameters for cachingAPIUpdateProxyDatabase operation in CachingAPIApi.
 * @export
 * @interface CachingAPIApiCachingAPIUpdateProxyDatabaseRequest
 */
export interface CachingAPIApiCachingAPIUpdateProxyDatabaseRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIUpdateProxyDatabase
     */
    readonly organizationId: string

    /**
     * Proxy identifier
     * @type {string}
     * @memberof CachingAPIApiCachingAPIUpdateProxyDatabase
     */
    readonly proxyId: string

    /**
     * Name of the database
     * @type {string}
     * @memberof CachingAPIApiCachingAPIUpdateProxyDatabase
     */
    readonly databaseName: string

    /**
     * 
     * @type {ProxyDatabaseUpdate}
     * @memberof CachingAPIApiCachingAPIUpdateProxyDatabase
     */
    readonly proxyDatabaseUpdate: ProxyDatabaseUpdate
}

/**
 * CachingAPIApi - object-oriented interface
 * @export
 * @class CachingAPIApi
 * @extends {BaseAPI}
 */
export class CachingAPIApi extends BaseAPI {
    /**
     * Create a cache rule for a specific logical database behind a proxy.   Adds a per-table or per-query TTL override rule. Exactly one of table or  template_hash must be set on the rule.
     * @summary Create a cache rule for a proxy database
     * @param {CachingAPIApiCachingAPICreateCacheRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CachingAPIApi
     */
    public cachingAPICreateCacheRule(requestParameters: CachingAPIApiCachingAPICreateCacheRuleRequest, options?: RawAxiosRequestConfig) {
        return CachingAPIApiFp(this.configuration).cachingAPICreateCacheRule(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.cacheRule, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a proxy for a database instance
     * @summary Create a proxy for a database instance
     * @param {CachingAPIApiCachingAPICreateProxyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CachingAPIApi
     */
    public cachingAPICreateProxy(requestParameters: CachingAPIApiCachingAPICreateProxyRequest, options?: RawAxiosRequestConfig) {
        return CachingAPIApiFp(this.configuration).cachingAPICreateProxy(requestParameters.organizationId, requestParameters.proxy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a cache rule for a specific logical database behind a proxy.
     * @summary Delete a cache rule for a proxy database
     * @param {CachingAPIApiCachingAPIDeleteCacheRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CachingAPIApi
     */
    public cachingAPIDeleteCacheRule(requestParameters: CachingAPIApiCachingAPIDeleteCacheRuleRequest, options?: RawAxiosRequestConfig) {
        return CachingAPIApiFp(this.configuration).cachingAPIDeleteCacheRule(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exchange current state for a specific proxy instance
     * @summary Exchange latest proxy state
     * @param {CachingAPIApiCachingAPIExchangeProxyStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CachingAPIApi
     */
    public cachingAPIExchangeProxyState(requestParameters: CachingAPIApiCachingAPIExchangeProxyStateRequest, options?: RawAxiosRequestConfig) {
        return CachingAPIApiFp(this.configuration).cachingAPIExchangeProxyState(requestParameters.organizationId, requestParameters.proxyId, requestParameters.exchangeProxyStateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get instance-level cache metrics timeseries for all databases behind a proxy.   Returns per-bucket cache hits/projection for every database, server-side ranked  top-N databases by cache hits over the range, and direct-mode transition events.
     * @summary Get instance-level cache metrics timeseries for a proxy
     * @param {CachingAPIApiCachingAPIGetInstanceProxyCacheMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CachingAPIApi
     */
    public cachingAPIGetInstanceProxyCacheMetrics(requestParameters: CachingAPIApiCachingAPIGetInstanceProxyCacheMetricsRequest, options?: RawAxiosRequestConfig) {
        return CachingAPIApiFp(this.configuration).cachingAPIGetInstanceProxyCacheMetrics(requestParameters.organizationId, requestParameters.proxyId, requestParameters.startTime, requestParameters.endTime, requestParameters.stepSeconds, requestParameters.topN, requestParameters.databaseId, requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get cache metrics timeseries for a specific logical database behind a proxy.   Returns per-bucket metrics data, optionally filtered down to a single query template hash.
     * @summary Get cache metrics timeseries for a proxy database
     * @param {CachingAPIApiCachingAPIGetProxyCacheMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CachingAPIApi
     */
    public cachingAPIGetProxyCacheMetrics(requestParameters: CachingAPIApiCachingAPIGetProxyCacheMetricsRequest, options?: RawAxiosRequestConfig) {
        return CachingAPIApiFp(this.configuration).cachingAPIGetProxyCacheMetrics(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.startTime, requestParameters.endTime, requestParameters.stepSeconds, requestParameters.templateHash, requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get per-template query insights for a specific logical database behind a proxy.   Returns timeseries of query insights (cache miss latency percentiles, TTL bounds, unique query/result counts)  plus an aggregate summary over the requested period.
     * @summary Get cache query insights for a proxy database
     * @param {CachingAPIApiCachingAPIGetProxyCacheQueryInsightsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CachingAPIApi
     */
    public cachingAPIGetProxyCacheQueryInsights(requestParameters: CachingAPIApiCachingAPIGetProxyCacheQueryInsightsRequest, options?: RawAxiosRequestConfig) {
        return CachingAPIApiFp(this.configuration).cachingAPIGetProxyCacheQueryInsights(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.templateHash, requestParameters.startTime, requestParameters.endTime, requestParameters.stepSeconds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the normalized SQL template string for a specific template hash.
     * @summary Get cache query template for a proxy database
     * @param {CachingAPIApiCachingAPIGetProxyCacheQueryTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CachingAPIApi
     */
    public cachingAPIGetProxyCacheQueryTemplate(requestParameters: CachingAPIApiCachingAPIGetProxyCacheQueryTemplateRequest, options?: RawAxiosRequestConfig) {
        return CachingAPIApiFp(this.configuration).cachingAPIGetProxyCacheQueryTemplate(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.templateHash, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get an aggregated cache summary for a specific logical database behind a proxy.   Returns totals and rates (actual, projected, and optimal) over the requested period.
     * @summary Get cache summary for a proxy database
     * @param {CachingAPIApiCachingAPIGetProxyCacheSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CachingAPIApi
     */
    public cachingAPIGetProxyCacheSummary(requestParameters: CachingAPIApiCachingAPIGetProxyCacheSummaryRequest, options?: RawAxiosRequestConfig) {
        return CachingAPIApiFp(this.configuration).cachingAPIGetProxyCacheSummary(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.startTime, requestParameters.endTime, requestParameters.username, requestParameters.templateHash, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get connections timeseries for the databases behind a proxy.   Returns per-bucket connection usage summed across databases: the client  connections into DBO (incoming) alongside the connections DBO holds against  the upstream database (outgoing). Covers every database behind the proxy  unless narrowed with database_id.
     * @summary Get connections timeseries for a proxy
     * @param {CachingAPIApiCachingAPIGetProxyConnectionsMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CachingAPIApi
     */
    public cachingAPIGetProxyConnectionsMetrics(requestParameters: CachingAPIApiCachingAPIGetProxyConnectionsMetricsRequest, options?: RawAxiosRequestConfig) {
        return CachingAPIApiFp(this.configuration).cachingAPIGetProxyConnectionsMetrics(requestParameters.organizationId, requestParameters.proxyId, requestParameters.startTime, requestParameters.endTime, requestParameters.stepSeconds, requestParameters.databaseId, requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get performance metrics timeseries for the databases behind a proxy.   Returns per-bucket query performance metrics (total statements, reads,  writes, execution-time percentiles) plus an aggregate summary over the  requested period. Covers every database behind the proxy unless narrowed  with database_id.
     * @summary Get performance metrics timeseries for a proxy
     * @param {CachingAPIApiCachingAPIGetProxyPerformanceMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CachingAPIApi
     */
    public cachingAPIGetProxyPerformanceMetrics(requestParameters: CachingAPIApiCachingAPIGetProxyPerformanceMetricsRequest, options?: RawAxiosRequestConfig) {
        return CachingAPIApiFp(this.configuration).cachingAPIGetProxyPerformanceMetrics(requestParameters.organizationId, requestParameters.proxyId, requestParameters.startTime, requestParameters.endTime, requestParameters.stepSeconds, requestParameters.databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List queries seen by the proxy for a specific logical database.   Returns per-template aggregated query statistics (cache hits, misses, execution times, etc.)  derived from proxy query metrics over the requested period.
     * @summary List queries seen by the proxy for a database
     * @param {CachingAPIApiCachingAPIGetProxyQueriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CachingAPIApi
     */
    public cachingAPIGetProxyQueries(requestParameters: CachingAPIApiCachingAPIGetProxyQueriesRequest, options?: RawAxiosRequestConfig) {
        return CachingAPIApiFp(this.configuration).cachingAPIGetProxyQueries(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, requestParameters.startTime, requestParameters.endTime, requestParameters.queryContains, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List cache rules for a specific logical database behind a proxy.   Returns the per-table and per-query TTL override rules configured for the database.
     * @summary List cache rules for a proxy database
     * @param {CachingAPIApiCachingAPIListCacheRulesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CachingAPIApi
     */
    public cachingAPIListCacheRules(requestParameters: CachingAPIApiCachingAPIListCacheRulesRequest, options?: RawAxiosRequestConfig) {
        return CachingAPIApiFp(this.configuration).cachingAPIListCacheRules(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.table, requestParameters.templateHash, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Report operational metrics (connection pool gauges) from the proxy
     * @summary Report operational metrics from proxy
     * @param {CachingAPIApiCachingAPIReportOperationalMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CachingAPIApi
     */
    public cachingAPIReportOperationalMetrics(requestParameters: CachingAPIApiCachingAPIReportOperationalMetricsRequest, options?: RawAxiosRequestConfig) {
        return CachingAPIApiFp(this.configuration).cachingAPIReportOperationalMetrics(requestParameters.organizationId, requestParameters.proxyId, requestParameters.reportOperationalMetricsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Report pooling metrics (connection pool gauges) from the pooler
     * @summary Report pooling metrics from the pooler
     * @param {CachingAPIApiCachingAPIReportPoolingMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CachingAPIApi
     */
    public cachingAPIReportPoolingMetrics(requestParameters: CachingAPIApiCachingAPIReportPoolingMetricsRequest, options?: RawAxiosRequestConfig) {
        return CachingAPIApiFp(this.configuration).cachingAPIReportPoolingMetrics(requestParameters.organizationId, requestParameters.proxyId, requestParameters.reportPoolingMetricsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Report a batch of query metrics from the proxy
     * @summary Report query metrics from proxy
     * @param {CachingAPIApiCachingAPIReportQueryMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CachingAPIApi
     */
    public cachingAPIReportQueryMetrics(requestParameters: CachingAPIApiCachingAPIReportQueryMetricsRequest, options?: RawAxiosRequestConfig) {
        return CachingAPIApiFp(this.configuration).cachingAPIReportQueryMetrics(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.reportQueryMetricsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a cache rule for a specific logical database behind a proxy.   Replaces the mutable fields of an existing rule. Output-only fields are ignored.
     * @summary Update a cache rule for a proxy database
     * @param {CachingAPIApiCachingAPIUpdateCacheRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CachingAPIApi
     */
    public cachingAPIUpdateCacheRule(requestParameters: CachingAPIApiCachingAPIUpdateCacheRuleRequest, options?: RawAxiosRequestConfig) {
        return CachingAPIApiFp(this.configuration).cachingAPIUpdateCacheRule(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.id, requestParameters.cacheRule, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a logical database behind a proxy   Only fields present in the request are updated;  omitted fields are left unchanged.
     * @summary Update a logical database behind a proxy
     * @param {CachingAPIApiCachingAPIUpdateProxyDatabaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CachingAPIApi
     */
    public cachingAPIUpdateProxyDatabase(requestParameters: CachingAPIApiCachingAPIUpdateProxyDatabaseRequest, options?: RawAxiosRequestConfig) {
        return CachingAPIApiFp(this.configuration).cachingAPIUpdateProxyDatabase(requestParameters.organizationId, requestParameters.proxyId, requestParameters.databaseName, requestParameters.proxyDatabaseUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CachingAPIGetProxyQueriesSortOrderEnum = {
    ASC: 'ASC',
    asc: 'asc',
    DESC: 'DESC',
    desc: 'desc'
} as const;
export type CachingAPIGetProxyQueriesSortOrderEnum = typeof CachingAPIGetProxyQueriesSortOrderEnum[keyof typeof CachingAPIGetProxyQueriesSortOrderEnum];
